// The app's one sign-in session (kast-common's auth module), and the
// sign-in and sign-out trips around it.

import {
  createAdminMode,
  createSession,
  hostedUiLogoutUrl,
  localStorageTokenStore,
  navigateTo,
  takeTokensFromUrl,
} from "@jkast90/kast-common/auth";
import { getDeploymentConfig } from "@common/deployment-config";

/** Where a sign-in lands when it started from the home page. */
export const DEFAULT_LANDING = "/admin/sites";

const { cognitoDomain, clientId } = getDeploymentConfig();

export const session = createSession({
  cognitoDomain,
  clientId,
  store: localStorageTokenStore({ alsoClear: ["userEmail"] }),
});

/** Admin tools: on for the admin group until switched off in Settings (on this device). */
export const ADMIN_GROUPS = ["admin"] as const;
export const adminMode = createAdminMode({ admin: ADMIN_GROUPS, storageKey: "kast-dev-admin.adminMode" });

/**
 * Back from login.kast-dev.net: store the hash's tokens and scrub them from
 * the URL, then move to where the user was going. Run before the first render.
 */
export function completeSignIn(): void {
  const taken = takeTokensFromUrl(session);
  if (!taken) return;
  const target = taken.returnTo ?? (window.location.pathname === "/" ? DEFAULT_LANDING : null);
  if (target) window.history.replaceState(null, "", target);
}

/**
 * Revoke, clear, then end the hosted UI's session too, without showing the
 * page signed out first. Unconfigured (local development), the logout URL is
 * just this site's origin.
 */
export function signOut(): Promise<void> {
  return session.signOut({
    leave: () => navigateTo(hostedUiLogoutUrl({ cognitoDomain, clientId, logoutUri: window.location.origin })),
  });
}
